// get cssgrid working for the extra +15 button et al.
// import './layout.css';
import { smlr } from '../../util.js';
import m from 'mithril';
import { preambleMC} from './preamble.js';
import { gsap } from 'gsap';
import { ExpoScaleEase } from "gsap/EasePack";
import TextPlugin from "gsap/TextPlugin";
gsap.registerPlugin(ExpoScaleEase);
gsap.registerPlugin(TextPlugin);

let wakeLockOBJ = null;
let wakeLockStatus = "";
let clickCT = 0;
let breathCT = 1;

let breatheMC = {
  oncreate: function(vnode) {
    let tl = gsap.timeline();
    tl.repeatDelay(4);
    tl.to(".dot", {scale: 2, duration: 4, "background-color": "#0000ff", ease: "expoScale(0.5,7,power1.inOut)",}); // BLUE
    tl.to(".dot", {scale: 0.4, duration: 4, "background-color": "#00ff00", ease: "expoScale(0.5,7,power1.inOut)",}, // GREEN
       "+=4"); // green
    tl.repeat(-1); // repeat indefinitely

    let t2 = gsap.timeline();
    t2.repeatDelay(0);
    t2.to(".counter", {duration:1, text: "1", ease: "none"});
    t2.to(".counter", {duration:1, text: "2", ease: "none"});
    t2.to(".counter", {duration:1, text: "3", ease: "none"});
    t2.to(".counter", {duration:1, text: "4", ease: "none"});
    t2.repeat(-1); // repeat indefinitely
	},
  view: function(e) {
    let result = m("span", {
      class: "dot",
      onclick: function(e) {
        clickCT++;
        // wakeLockStatus = `wake lock activated: #${clickCT}`; // works here
        if (wakeLockOBJ === null) {
          // previous wake lock obj nulled out or non-existent
          navigator.wakeLock.request('screen').then(res => {
            wakeLockStatus = `wake lock activated: #${clickCT}, ${res.released}`; // works here
            wakeLockOBJ = res;
            console.log(`wLr: ${res}`);
            console.log(`wLr activate: ${wakeLockStatus}`);
          });
        } else {
          // previous wake lock obj exists
          console.log(`not null: ${wakeLockOBJ}`);
          wakeLockOBJ.release().then(res => {
            wakeLockOBJ = null;
            wakeLockStatus = `wake lock de-activated: #${clickCT}, ${wakeLockOBJ}`; // works here
            console.log(`wLr deactivate: ${wakeLockStatus}`);
          });
        }

      },
    });
    return(result);
  }
};

let counterMC = {
  view: function(vnode) {
    return(m("div", {
      class: "counter"
    }, `0`));
  }
};

let wlBMC = {
  view: function(vnode) {
    return(m("div", {}, wakeLockStatus));
  }
};

let splash4444 = {
  view: function(vnode) {
    var result = [
      m(preambleMC, vnode.attrs),
      m(wlBMC, vnode.attrs),      
      m("div", {}, "4-4-4-4 (box) pattern"),
      m("div", {}, `COUNT: ${breathCT}`),
      m("div", {class: "container"}, [
        m(breatheMC, vnode.attrs),
        m(counterMC, vnode.attrs),
      ]),
    ];
    
    return(result);
  }
};

export { splash4444 };